import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const ServiceList = (services) => {
  return (
  <div className='service--list p10'>
    <div className='grid'>
      {services.services.map((service,index) => {
          
          return (
            <div key={index} className='text-center'>
              <p className='m0 uppercase mb30 text-light ls-1'>{service.title}</p>
              <div className='ratio-1-2 bg-dark pos-rel'>
                <GatsbyImage className='bg-image' image={service.image?.gatsbyImageData} alt={service.title} />
              </div>
              <div className='content mt30 lh-135 max-400 ma pl40 pr40'> 
                {service.description}
              </div>
            </div>
          )
      })}
    </div>
  </div> 
  ) 
}
export default ServiceList
